import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractUserRelatedDataService } from '@y42/feature';
import { StatusAlertState } from './status-alert.model';
import { StatusAlertQuery } from './status-alert.query';
import { StatusAlertStore } from './status-alert.store';

@Injectable({ providedIn: 'root' })
export class StatusAlertUserDataService extends AbstractUserRelatedDataService<StatusAlertState> {
  constructor(readonly http: HttpClient, readonly store: StatusAlertStore, readonly query: StatusAlertQuery) {
    super({
      http,
      store,
      query,
      URLs: {
        last_used: 'status-alert-last-used',
        starred: 'status-alert-starred',
      },
    });
  }
}
